import { Col, Row } from "reactstrap";
import Checkbox from "../../../../../components/common/Checkbox/Checkbox";
import Toggle from "../../../../../components/common/Toggle/Toggle";
import YellowHeaderWrapper from "../../../../../components/common/YellowHeaderWrapper/YellowHeaderWrapper";
import CustomDropdown from "../../../../../components/common/Dropdown/CustomDropDown";

const AdditionalSetting = () => {
  return (
    <section>
      <YellowHeaderWrapper title={"Notification"}>
        <Row className="g-0 align-items-center justify-content-between">
          <Col xs={"auto"} lg={4} xl={3} xxl={2}>Chat notification:</Col>
          <Col xs={"auto"} lg={8} xl={9} xxl={10} className="d-flex py-2">
            <Toggle />
          </Col>
        </Row>
        <Row className="g-0 align-items-center justify-content-between">
          <Col xs={"auto"} lg={4} xl={3} xxl={2}>Notification Sound:</Col>
          <Col xs={"auto"} lg={8} xl={9} xxl={10} className="d-flex py-2">
            <Toggle />
          </Col>
        </Row>
        <Row className="g-0 align-items-center justify-content-between">
          <Col xs={"auto"} lg={4} xl={3} xxl={2}>Vibration:</Col>
          <Col xs={"auto"} lg={8} xl={9} xxl={10} className="d-flex py-2">
            <Toggle />
          </Col>
        </Row>
        <Row className="g-0 row-gap-1">
          <Col lg={4} xl={3} xxl={2}>Notification Preview:</Col>
          <Col lg={8} xl={9} xxl={10}>
            <div>
              <label className="d-flex align-items-center gap-1">
                <Checkbox />
                <span>None</span>
              </label>
              <label className="d-flex align-items-center gap-1">
                <Checkbox />
                <span>Sender name</span>
              </label>
              <label className="d-flex align-items-center gap-1">
                <Checkbox />
                <span>Message Preview</span>
              </label>
            </div>
          </Col>
        </Row>
      </YellowHeaderWrapper>

      <YellowHeaderWrapper title={"Privacy"}>
        <Row className="g-0 row-gap-1">
          <Col lg={4} xl={3} xxl={2}>Last Seen Visibility:</Col>
          <Col lg={8} xl={9} xxl={10}>
            <div>
              <label className="d-flex align-items-center gap-1">
                <Checkbox />
                <span>Immediately (as soon as the event occurs)</span>
              </label>
            </div>
            <div>
              <label className="d-flex align-items-center gap-1">
                <Checkbox />
                <span>Daily summary (once a day at a specified time)</span>
              </label>
            </div>
            <div>
              <label className="d-flex align-items-center gap-1">
                <Checkbox />
                <span>
                  Weekly summary (once a week at a specified day and time)
                </span>
              </label>
            </div>
          </Col>
        </Row>
        <Row className="g-0 align-items-center justify-content-between">
          <Col xs={"auto"} lg={4} xl={3} xxl={2}>Read Receipts:</Col>
          <Col xs={"auto"} lg={8} xl={9} xxl={10} className="d-flex py-2">
            <Toggle />
          </Col>
        </Row>
        <Row className="g-0 row-gap-1 align-items-center">
          <Col lg={4} xl={3} xxl={2}>Profile Visibility:</Col>
          <Col lg={6} xl={5} xxl={4}>
            <div className="border border-subtle-secondary rounded p-2">
              <CustomDropdown title={"Select from dropdown"} />
            </div>
          </Col>
        </Row>
      </YellowHeaderWrapper>

      <YellowHeaderWrapper title={"Advanced Setting"}>
        <Row className="g-0">
          <Col lg={4} xl={3} xxl={2}>Theme:</Col>
          <Col lg={8} xl={9} xxl={10}>
            <div>
              <label className="d-flex align-items-center gap-1">
                <Checkbox />
                <span>Dark mode</span>
              </label>
              <label className="d-flex align-items-center gap-1">
                <Checkbox />
                <span>Light Mode</span>
              </label>
            </div>
          </Col>
        </Row>
        <Row className="g-0">
          <Col lg={4} xl={3} xxl={2}>Wallpaper:</Col>
          <Col lg={8} xl={9} xxl={10}>
            <div className="d-flex gap-2">
              {[1, 2, 3, 4, 5, 6].map((item) => (
                <div
                  key={item}
                  style={{
                    height: "76.03px",
                    width: "66px",
                    backgroundColor: "#F2F2F2",
                  }}
                  className="rounded cursor-pointer"
                ></div>
              ))}
            </div>
          </Col>
        </Row>
        <Row className="g-0 align-items-center">
          <Col lg={4} xl={3} xxl={2}>Language:</Col>
          <Col lg={6} xl={5} xxl={4}>
            <div className="border border-subtle-secondary rounded p-2">
              <CustomDropdown title={"Select from dropdown"} />
            </div>
          </Col>
        </Row>
      </YellowHeaderWrapper>
    </section>
  );
};

export default AdditionalSetting;